<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  setValueOnEditPageData,
  valueChanged,
} from "@/editor/EditComponentStatic";
const props = defineProps<EditControlProps>();
const emitFn = defineEmits<CommonEditControlEmits>();
const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
const uiData = reactive(ui);

onMounted(() => {
  mounted(uiData, props, config);
  const hasExplicitInitValue =
    config.initValue !== undefined && config.initValue !== null;
  if (!hasExplicitInitValue && config.column?.meta?.neuArt === "Limit") {
    config.initValue = true;
    uiData.data = true;
    setValueOnEditPageData(config, uiData, true, true);
  } else if (!hasExplicitInitValue) {
    config.initValue = false;
    uiData.data = false;
  }
});
function textChanged() {
  valueChanged(config, uiData, uiData.data);
}
</script>

<template>
  <div v-if="uiData.showMutable" class="wrap">
    <v-tooltip
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-checkbox
          v-bind="props"
          @change="textChanged"
          v-model="uiData.data"
          :label="uiData.description"
          variant="solo"
          density="compact"
          color="warning"
          :required="uiData.required"
          persistent-hint
          :error-messages="uiData.errorText"
          :disabled="uiData.disabled"
        ></v-checkbox>
        <ValueChangeTracker v-if="uiData.isChanged || props.disableValueChangeTracker" />
      </template>
    </v-tooltip>
  </div>
</template>
<style scoped></style>
